<mat-card>
  <mat-card-header>
    <mat-card-title>
      <h1>TextError Technologies</h1>
    </mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>
  <img matCardImage style="width: calc(35% + 17px);margin: 0 0 0px 30%;" src="../../../assets/logo.png">
  <mat-card-content>
    Bangalore - 560078
  </mat-card-content>
</mat-card>
